export const routes = {
    '/': ['SuperAdmin', 'Data Entry Operator', 'Fitness Officer', 'Deputy Director', 'DC Office'],
    '/usersdata': ['SuperAdmin'],
    '/registrationFeeManagement': ['SuperAdmin'],
    '/feefinemanagement': ['SuperAdmin'],
    '/routes-management': ['SuperAdmin'],
    '/Reports': [ 'Deputy Director', 'DC Office'],
    '/permit-requests': ['SuperAdmin', 'Data Entry Operator', 'Deputy Director', 'DC Office'],
    '/permit-requests/add': ['SuperAdmin', 'Data Entry Operator'],
    '/permit-requests/edit/:id': ['SuperAdmin', 'Data Entry Operator'],
    '/permit-requests/view/:id': ['SuperAdmin', 'Data Entry Operator', 'Deputy Director', 'DC Office'],
    '/permit-renewal': ['SuperAdmin', 'Data Entry Operator'],
    '/permit-renewal/add': ['SuperAdmin', 'Data Entry Operator'],
    '/permit-renewal/edit/:id': ['SuperAdmin', 'Data Entry Operator'],
    '/permit-renewal/view/:id': ['SuperAdmin', 'Data Entry Operator'],
    '/fitnessCertificate': ['SuperAdmin', 'Fitness Officer'],
    '/addfitness': ['SuperAdmin', 'Fitness Officer'],
    '/fitnesscer': ['SuperAdmin', 'Fitness Officer'],
    '/fitnessrenewal': ['SuperAdmin', 'Fitness Officer'],
    '/batch-management': ['SuperAdmin', 'Data Entry Operator', 'Fitness Officer'],
};
